import React from "react";

const TopBar = () => {
  return (
    <div className="flex justify-between items-center px-4 py-4 bg-slate-800"></div>
  );
};

export default TopBar;
